module.exports = __webpack_public_path__ + "img/mobile.58910971.png";